import { NOTIF_TYPES } from '@private/notifications';

import { baseThemeValues } from 'constants/common';

const ntfBase = {
  bg: 'palette.surface.4',
  borderRadius: '8px',
  borderWidth: '1px',
  boxShadow: 'palette.black:0.5',
  loader: {
    back: 'palette.surface.5',
    front: 'palette.secondary.50',
  },
};

const titleBase = {
  fontFamily: baseThemeValues.inherit,
  fontSize: '14px',
  fontWeight: 600,
};

export const notificationTheme = {
  baseProps: ntfBase,
  [NOTIF_TYPES.ERROR]: {
    ...ntfBase,
    borderColor: 'palette.error.60',
    icon: {
      bgCircle: 'palette.error.90',
      frontCircle: 'palette.error.80',
      icon: 'palette.error.10',
    },
    message: 'palette.tertiary.99',
    title: { ...titleBase, text: 'palette.error.40' },
  },
  [NOTIF_TYPES.INFO]: {
    ...ntfBase,
    borderColor: 'palette.tertiary.40',
    icon: {
      bgCircle: 'palette.tertiary.10',
      frontCircle: 'palette.tertiary.20',
      icon: 'palette.tertiary.80',
    },
    message: 'palette.tertiary.95',
    title: { ...titleBase, text: 'palette.tertiary.60' },
  },
  [NOTIF_TYPES.LOADING]: {
    ...ntfBase,
    borderColor: 'palette.secondary.20',
    message: 'palette.tertiary.95',
    title: { ...titleBase, text: 'palette.secondary.60' },
  },
  [NOTIF_TYPES.SUCCESS]: {
    ...ntfBase,
    borderColor: 'palette.success.20',
    icon: {
      bgCircle: 'palette.success.10',
      frontCircle: 'palette.success.20',
      icon: 'palette.success.80',
    },
    message: 'palette.tertiary.99',
    title: { ...titleBase, text: 'palette.success.60' },
  },
  [NOTIF_TYPES.WARNING]: {
    ...ntfBase,
    borderColor: 'palette.warning.30',
    icon: {
      bgCircle: 'palette.warning.10',
      frontCircle: 'palette.warning.20',
      icon: 'palette.warning.80',
    },
    message: 'palette.tertiary.95',
    title: { ...titleBase, text: 'palette.warning.60' },
  },
  titleBase,
};
